export const MODULE_ID = "VirtoCommerce.Loyalty";
export const ENABLED_KEY = "Loyalty.Enable";
export const MISSIONS_ENABLED_KEY = "Loyalty.Missions.Enable";

export const DEFAULT_LOYALTY_LOGS_PER_PAGE = 10;
export const DEFAULT_MISSIONS_PER_PAGE = 12;

export const CUSTOMER_ORDER_OBJECT_TYPE = "CustomerOrder";
export const REGISTRATION_OBJECT_TYPE = "Registration";
export const MISSION_OBJECT_TYPE = "Mission";
export const REDEEMED_OPERATION = "Redeemed";
export const EARNED_OPERATION = "Earned";
export const LOYALTY_PAYMENT_TYPE_NAME = "LoyaltyPaymentMethod";
